import { Fragment, FC, useMemo } from 'react';
import { Heading } from '@qga/roo-ui/components';

import { InfoModal } from 'components/Layout';
import { SelfServiceAPI } from 'types';
import { sanitizeHTML } from 'lib/utils';
import { BreakOnNewLine } from 'components/Typography';

interface PropertyInformationModalProps {
  booking: SelfServiceAPI.Booking;

  [key: string]: any;
}

const PropertyInformationModal: FC<PropertyInformationModalProps> = ({ booking, ...modalProps }) => {
  const { property } = booking.reservation;
  const html = useMemo(
    () => ({
      description: sanitizeHTML(property.description),
      checkInInstructions: sanitizeHTML(property.checkInInstructions),
      hotelPolicies: sanitizeHTML(property.roomInformation),
    }),
    [property],
  );

  return (
    <InfoModal title="Property Information" {...modalProps}>
      <InfoModal.body p="5" pb="10">
        <Heading.h4>Description</Heading.h4>
        <BreakOnNewLine dangerouslySetInnerHTML={{ __html: html.description }} />

        {html.checkInInstructions && (
          <Fragment>
            <Heading.h4 mt={6}>Check-In Instructions</Heading.h4>
            <BreakOnNewLine dangerouslySetInnerHTML={{ __html: html.checkInInstructions }} />
          </Fragment>
        )}

        {html.hotelPolicies && (
          <Fragment>
            <Heading.h4 mt={6}>Hotel Policies</Heading.h4>
            <BreakOnNewLine dangerouslySetInnerHTML={{ __html: html.hotelPolicies }} />
          </Fragment>
        )}
      </InfoModal.body>
    </InfoModal>
  );
};

export default PropertyInformationModal;
